import { render } from "./Home.vue?vue&type=template&id=3efa37e3"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=3efa37e3&lang=css"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/dynamik_webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__